import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { ReactElement } from 'react'
import { MUIButton, MUIDialog, ModalIcon } from '../'
import { getSanitizedValue } from '../../../Helpers/Util'

export interface ConfirmDialogProps {
  open: boolean
  title?: string
  description?: string
  icon?: string
  btn1Label?: string
  btn1Color?: 'primary' | 'secondary' | 'warning' | 'error'
  btn1Variant?: 'contained' | 'outlined'
  btn2Label?: string
  btn2Color?: 'primary' | 'secondary' | 'warning' | 'error'
  btn2Variant?: 'contained' | 'outlined'
  btn2Disabled?: boolean
  onCloseDialog?: () => void
  onConfirm?: (() => void) | (() => Promise<void>)
  onClose?: () => void
  extraUI?: ReactElement
  width?: any
  testID1?: string
  testID2?: string
  disableBackdropClose?: boolean
  btn1Disabled?: boolean
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  description,
  icon,
  btn1Label,
  btn1Color = 'secondary',
  btn1Variant = 'outlined',
  btn2Label,
  btn2Color = 'primary',
  btn2Variant = 'contained',
  btn2Disabled = false,
  testID1,
  testID2,
  onCloseDialog,
  onConfirm,
  onClose,
  extraUI,
  width = '354px',
  disableBackdropClose = false,
  btn1Disabled = false,
}) => {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm()
    }
    if (onCloseDialog) {
      onCloseDialog()
    }
  }

  const handleClose = () => {
    if (onCloseDialog) {
      onCloseDialog()
    }
    if (onClose) {
      onClose()
    }
  }

  return (
    <MUIDialog
      open={open}
      handleClose={
        disableBackdropClose
          ? (((_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') return
              handleClose()
            }) as any)
          : handleClose
      }
    >
      <div className='c-modal' style={{ width, minWidth: '100%' }}>
        {icon && (
          <DialogTitle>
            <ModalIcon IconName={icon} />
          </DialogTitle>
        )}
        <DialogContent>
          {(title || description) && (
            <DialogContentText component={'div'} id='alert-dialog-slide-description'>
              {title && <div className='col2 parag pt-1raph-bold-3 '>{title}</div>}
              {description && (
                <div
                  className='col34 paragraph-regular-5'
                  dangerouslySetInnerHTML={{ __html: getSanitizedValue(description) }}
                />
              )}
            </DialogContentText>
          )}
          {extraUI}
        </DialogContent>
        <DialogActions>
          <div className={`d-flex flex-wrap w-100 p-0 ${btn2Label && btn1Label && 'dialog-btns'} `}>
            {btn1Label && (
              <div className={`cancel-action-btn ${!btn2Label && 'w-100'}`}>
                <MUIButton
                  variant={btn1Variant}
                  color={btn1Color}
                  type='button'
                  label={btn1Label}
                  width={'100%'}
                  handleClickCB={handleClose}
                  testID={testID1}
                  disabled={btn1Disabled}
                />
              </div>
            )}
            {btn2Label && (
              <div className={`accept-action-btn ${!btn1Label && 'w-100'}`}>
                <MUIButton
                  disabled={btn2Disabled}
                  variant={btn2Variant}
                  size='large'
                  color={btn2Color}
                  type='button'
                  label={btn2Label}
                  width={'100%'}
                  handleClickCB={handleConfirm}
                  testID={testID2}
                />
              </div>
            )}
          </div>
        </DialogActions>
      </div>
    </MUIDialog>
  )
}

export default ConfirmDialog
